<app-base-template (modal)="openModal(content)" (searchmodal) = "searchModal()" (dataExportToExcel)="exportToExcel()" (tabledata)="getTableData()" [displayData]="displayData" [nextOffset]="nextOffset"
                   [previousOffset]="previousOffset" (offset)="getData($event)"
                   (pageSize)="onPageSizeChange($event)" [pageNo]="page_no" [totalPage]="totalPage"[isExportDisable]="isExportDisable"[showExportBtn]="showExportBtn"[showSearch]="showSearch"[dataLoaded]="dataLoaded"></app-base-template>
<ng-template #content let-c="close" let-d="dismiss">
    <div class="modal-header modalTitle">
        <div class="modal-title">Add Escalation</div>

    </div>
    <div class="modal-body">
        <div class="none" [ngClass]="{'inputError':isError}">{{errorMessage}}</div>
        <div class="form-group">
            <select class="custom-select mr-sm-2 radius-0 font-13" [(ngModel)]="ticketSelected"
                    (change)="onTicketChange($event.target.selectedIndex)">
                <option *ngFor="let ticket of ttypes" [value]="ticket.id">{{ticket.name}}</option>
            </select>
        </div>
        <div class="form-group">
            <select class="custom-select mr-sm-2 radius-0 font-13" [(ngModel)]="categorySelected"
                    (change)="onCategoryChange($event.target.selectedIndex)">
                <option *ngFor="let category of categories" [value]="category.id">{{category.name}}</option>
            </select>
        </div>

        <div class="form-group">
            <select class="custom-select mr-sm-2 radius-0 font-13" [(ngModel)]="prioritySelected"
                    (change)="onPriorityChange($event.target.selectedIndex)">
                <option *ngFor="let priority of priorities" [value]="priority.id">{{priority.name}}</option>
            </select>
        </div>


        <div class="form-group">
            <select class="custom-select mr-sm-2 radius-0 font-13" [(ngModel)]="notificationSelected"
                    (change)="onCategoryChange($event.target.selectedIndex)">
                <option *ngFor="let notification of notificationType" [value]="notification.id">{{notification.name}}</option>
            </select>
        </div>

        <div class="form-group">
            <input type="text" class="form-control radius-0 font-13" [(ngModel)]="notification_subject"
                   placeholder="Notification subject">
        </div>

        <div class="form-group">
            <input type="text" class="form-control radius-0 font-13" [(ngModel)]="additionalEmail"
                   placeholder="Additional email for escalation">
        </div>

        <div class="form-group">
            <label class="font-13">Content</label>
            <ck-editor name="editor1" [(ngModel)]="editorValue" skin="moono-lisa" language="en" [fullPage]="true" placeholder="Template body"></ck-editor>
        </div>

        <label class="font-13">Escalated Support Group</label>
        <div class="form-group font-13 box">
            <mat-radio-group (change)="onEscalateSupportGroupChecked($event)">
                <mat-radio-button *ngFor="let egroup of escalatedSupportGroup;" [value]="egroup.id" [checked]="egroup.checked">{{egroup.name}}&nbsp;</mat-radio-button> &nbsp;
            </mat-radio-group>
        </div>

        <div class="form-group" [hidden]="isHideSupportGroup">
            <select class="custom-select mr-sm-2 radius-0 font-13" [(ngModel)]="groupSelected"
                    (change)="onGroupChange($event.target.selectedIndex)">
                <option *ngFor="let group of groups" [value]="group.id">{{group.name}}</option>
            </select>
        </div>

        <div class="form-group">
            <input type="text" class="form-control radius-0 font-13" [(ngModel)]="escalationTime"
                   placeholder="Escalation time">
            <label class="font-13 labelcolor">* Daily in 24 hours format</label>
        </div>

        <label class="font-13">Escalate When</label>
        <div class="form-group font-13 box">
            <mat-radio-group (change)="onEscalateTimeChangeChange($event)">
                <mat-radio-button *ngFor="let ewhen of escalateWhen;" [value]="ewhen.id" [checked]="ewhen.checked">{{ewhen.name}}&nbsp;</mat-radio-button> &nbsp;
            </mat-radio-group>
        </div>

        <div class="form-group">
            <input type="text" class="form-control radius-0 font-13" [(ngModel)]="escalate_given_time"
                   placeholder="Escalate given time(in minutes)">
        </div>

        <label class="font-13" *ngIf = "!isSupp">SLA Alert (Client Res. - {{res}} min)</label>
        <label class="font-13"*ngIf = "isSupp">SLA Alert (Client Res. - {{res}} min & SG Res. - {{sgRes}} min)</label>

        <div class="form-group font-13 box">
            <mat-radio-group (change)="onSlaAlertChange($event)">
                <mat-radio-button *ngFor="let sla of slaAlert;" [value]="sla.id" [checked]="sla.checked">{{sla.name}}&nbsp;</mat-radio-button> &nbsp;
            </mat-radio-group>
        </div>

        <div class="form-group">
            <input type="text" class="form-control radius-0 font-13" [(ngModel)]="slaGivenTime"
                   placeholder="SLA given time(in minutes)">
        </div>

    </div>
    <div class="modal-footer pad-8">
        <button type="button" class="btn btn-success radius-0" (click)="save()">Save</button>
        <button type="button" class="btn btn-danger radius-0" (click)="c()">Cancel</button>
    </div>
</ng-template>



<ng-template #scarch_content let-c="close" let-d="dismiss">
    <div class="modal-header modalTitle">
      <div class="modal-title">Search</div>
    </div>
    <div class="modal-body">
  
        <div class="form-group mar_top">
            <input type="text" class="form-control radius-0 font-13"  placeholder=" Enter category Name"
                   [(ngModel)]="catSelected">
        </div>
    </div>
    <div class="modal-footer pad-8">
            <button type="button" class="btn btn-success float-right radius-0" (click)="search()">search</button>
            <button type="button" class="btn btn-danger radius-0" (click)="c()">Cancel</button>
    </div>
  
    </ng-template>
<notifier-container></notifier-container>
